import PaginatorView from 'component/paginator/paginator'
import GroupTeaserView from 'component/teaser_group/large'
import CallToActionView from 'component/cta/create_group/create_group'
import itemListGridTemplate from 'component/paginator/template/_itemListGrid.tmpl'
import paginatorTemplate from 'component/paginator/template/listOfItems.tmpl'
import dataProvider from 'service/data_provider'

export default PaginatorView.extend({
    options: null,

    defaultOptions: {
        teaserImageLinkRef: '',
        teaserTitleLinkRef: '',
        createGroupCTA: false,
    },

    initialize(options) {
        this.options = this.pickOptions(options, this.defaultOptions)

        options.templates = {
            base: paginatorTemplate,
            itemList: itemListGridTemplate,
        }

        PaginatorView.prototype.initialize.call(this, options)
    },

    renderItem(model) {
        return this.initSubview(GroupTeaserView, {
            model,
            imageLinkRef: this.options.teaserImageLinkRef,
            titleLinkRef: dataProvider.get('currentUser') && this.options.teaserTitleLinkRef,
        }).render()
    },

    renderCTAMessage() {
        if (!this.options.createGroupCTA) {
            return
        }

        return this.initSubview(CallToActionView, {
            className: 'whiteBox__section u-spaceLeft u-spaceRight',
        }).render()
    },

    renderEmptyMessage() {
        return this.renderCTAMessage()
    },
})
